import actions from "@/store/modules/speedNetworking/actions";
import getters from "@/store/modules/speedNetworking/getters";
import mutations from "@/store/modules/speedNetworking/mutations";

const state = {
  showEnterModal: false,
  enterInNetworking: false,
  waitingMeeting: true,
  userInMeeting: null,
  waitingTime: null,
  meetingTime: null,
};

export type State = typeof state;

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
